import gql from "graphql-tag";

export const SEARCH_RECORDS_LOCALLY = gql`
  query (
    $pageNumber: Int!
    $rowsPerPage: Int!
    $searchCriteria: recordSearchCriteria
  ) {
    searchLocalEntities(
      pageNumber: $pageNumber
      rowsPerPage: $rowsPerPage
      searchCriteria: $searchCriteria
    ) {
      statusCode
      message
      data
    }
  }
`;

export const SEARCH_RECORDS_FROM_MDM = gql`
  query (
    $name: String
    $dunsNumber: Int
    $city: String
    $state: String
    $countryCode: String
    $postCode: String
    $pageNumber: Int!
    $rowsPerPage: Int!
  ) {
    searchMDMEntity(
      name: $name
      dunsNumber: $dunsNumber
      city: $city
      state: $state
      countryCode: $countryCode
      postCode: $postCode
      pageNumber: $pageNumber
      rowsPerPage: $rowsPerPage
    ) {
      statusCode
      message
      data
    }
  }
`;

export const SEARCH_RECORDS_FROM_DNB = gql`
  query (
    $name: String
    $dunsNumber: Int
    $city: String
    $state: String
    $countryCode: String
    $postCode: String
    $pageNumber: Int!
    $rowsPerPage: Int!
  ) {
    searchDNBEntity(
      name: $name
      dunsNumber: $dunsNumber
      city: $city
      state: $state
      countryCode: $countryCode
      postCode: $postCode
      pageNumber: $pageNumber
      rowsPerPage: $rowsPerPage
    ) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY_ORG_STRUCTURE = gql`
  query ($entityId: String) {
    getParentsRecords(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY_ID_FROM_MDM_ID = gql`
  query ($mdmId: String) {
    getEntityIdFromMdmId(mdmId: $mdmId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY_ID_FROM_DUNS_NUMBER = gql`
  query ($dunsNumber: String) {
    getEntityIdFromDunsNumber(dunsNumber: $dunsNumber) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY = gql`
  query ($entityId: String!) {
    getEntity(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ASSOCIATIONS = gql`
  query (
    $entityId: String
    $entityCategory: String
    $entitySubcategory: String
  ) {
    getAssociations(
      entityId: $entityId
      entityCategory: $entityCategory
      entitySubcategory: $entitySubcategory
    ) {
      statusCode
      message
      data
    }
  }
`;

export const SEND_ASSOCIATIONS_TO_WC1 = gql`
  mutation ($entityId: String) {
    sendAssociationsToWc1(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const UPDATE_ASSOCIATIONS = gql`
  mutation (
    $sourceEntityId: String
    $targetEntityId: String
    $targetMdmId: String
    $targetDnbId: String
    $associations: [association1]
    $additionalInformation: additionalInformation
    $action: String
  ) {
    updateAssociations(
      sourceEntityId: $sourceEntityId
      targetEntityId: $targetEntityId
      targetMdmId: $targetMdmId
      targetDnbId: $targetDnbId
      associations: $associations
      additionalInformation: $additionalInformation
      action: $action
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_ASSOCIATION_ATTRIBUTE = gql`
  mutation (
    $sourceEntityId: String
    $targetEntityId: String
    $associationId: String
    $attributeId: String
    $dataType: String
    $value: String
  ) {
    updateAssociationAttribute(
      sourceEntityId: $sourceEntityId
      targetEntityId: $targetEntityId
      associationId: $associationId
      attributeId: $attributeId
      dataType: $dataType
      value: $value
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_ENTITY_ATTRIBUTES = gql`
  mutation ($entityId: String!, $attributes: [attribute], $action: String!) {
    updateEntity(
      entityId: $entityId
      attributes: $attributes
      action: $action
    ) {
      statusCode
      message
      data
    }
  }
`;

export const CREATE_ENTITY = gql`
  mutation (
    $entityName: String!
    $entityCategory: String!
    $addressLine1: String!
    $addressLine2: String
    $addressLine3: String
    $addressLine4: String
    $city: String!
    $county: String
    $stateProvince: String
    $region: String
    $postCode: String
    $countryId: String!
    $jllCountryId: String!
    $checkType: String!
  ) {
    createEntity(
      entityName: $entityName
      entityCategory: $entityCategory
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      addressLine3: $addressLine3
      addressLine4: $addressLine4
      city: $city
      county: $county
      stateProvince: $stateProvince
      region: $region
      postCode: $postCode
      countryId: $countryId
      jllCountryId: $jllCountryId
      checkType: $checkType
    ) {
      data
      statusCode
      message
    }
  }
`;

export const GET_DOCUMENT_TYPES = gql`
  query ($section: String) {
    getDocumentTypes(section: $section) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY_DOCUMENTS = gql`
  query ($entityId: String, $category: String) {
    getEntityDocuments(entityId: $entityId, category: $category) {
      statusCode
      message
      data
    }
  }
`;

export const GET_CHECK_VALIDITY_PERIOD = gql`
  query ($entityId: String, $checkType: String) {
    getValidityPeriod(
      entityId: $entityId
      checkType: $checkType
    ) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY_LINKS = gql`
  query ($entityId: String, $type: String) {
    getEntityLinks(entityId: $entityId, type: $type) {
      statusCode
      message
      data
    }
  }
`;

export const GET_ENTITY_COMMENT_HISTORY = gql`
  query ($entityId: String) {
    getCommentHistory(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const GET_FINALIZE_COMMENT = gql`
  query ($scoreId: String) {
    getUserFinalizeComment(scoreId: $scoreId) {
      statusCode
      message
      data
    }
  }
`;

export const FINALIZE_SCORE = gql`
  mutation (
    $entityId: String!
    $checkType: String!
    $acceptedScore: String
    $guidedScore: String
    $userComment: String
    $userValidFrom: String
    $userValidTo: String
    $proceedAtRisk: Boolean
  ) {
    finalizeScore(
      entityId: $entityId
      checkType: $checkType
      acceptedScore: $acceptedScore
      guidedScore: $guidedScore
      userComment: $userComment
      userValidFrom: $userValidFrom
      userValidTo: $userValidTo
      proceedAtRisk: $proceedAtRisk
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_CONFIDENTIALITY = gql`
  mutation ($entityId: String!, $confidential: Boolean) {
    updateConfidentiality(entityId: $entityId, confidential: $confidential) {
      statusCode
      message
    }
  }
`;

export const REQUEST_BLOCK = gql`
  query ($entityId: String!, $reason: String) {
    blockRequest(entityId: $entityId, reason: $reason) {
      statusCode
      message
    }
  }
`;

export const REQUEST_UNBLOCK = gql`
  query ($entityId: String!, $reason: String) {
    unblockRequest(entityId: $entityId, reason: $reason) {
      statusCode
      message
    }
  }
`;

export const CREATE_ENTITY_LINK = gql`
  mutation (
    $entityId: String!
    $url: String!
    $description: String
    $type: String!
  ) {
    addEntityLink(
      entityId: $entityId
      url: $url
      description: $description
      type: $type
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_ENTITY_LINK = gql`
  mutation (
    $id: String!
    $url: String!
    $description: String
    $entityId: String!
    $type: String!
  ) {
    updateEntityLink(
      id: $id
      url: $url
      description: $description
      entityId: $entityId
      type: $type
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_ENTITY_DOCUMENT_NAME = gql`
  mutation (
    $entityId: String!
    $documentId: String!
    $category: String!
    $documentName: String!
  ) {
    updateEntityDocumentName(
      entityId: $entityId
      documentId: $documentId
      category: $category
      documentName: $documentName
    ) {
      statusCode
      message
    }
  }
`;

export const REMOVE_ENTITY_LINK = gql`
  mutation ($id: String!, $entityId: String!, $type: String!) {
    removeEntityLink(id: $id, entityId: $entityId, type: $type) {
      statusCode
      message
    }
  }
`;

export const REMOVE_ENTITY_DOCUMENT = gql`
  mutation ($documentId: String!, $entityId: String!) {
    removeEntityDocument(documentId: $documentId, entityId: $entityId) {
      statusCode
      message
    }
  }
`;

export const DELETE_ENTITY_ASSOCIATION = gql`
  mutation (
    $entityId: String!
    $targetEntityId: String!
    $associationId: String
  ) {
    removeEntityAssociation(
      entityId: $entityId
      targetEntityId: $targetEntityId
      associationId: $associationId
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_ENTITY_ASSOCIATIONS = gql`
  mutation ($associations: [association]) {
    removeEntityAssociations(associations: $associations) {
      statusCode
      message
    }
  }
`;

export const REMOVE_ENTITY_CONTACT = gql`
  mutation ($id: String!, $entityId: String!) {
    removeEntityContact(id: $id, entityId: $entityId) {
      statusCode
      message
    }
  }
`;

export const CREATE_ENTITY_CONTACT = gql`
  mutation (
    $entityId: String!
    $addressType: String!
    $addressLine1: String!
    $addressLine2: String
    $addressLine3: String
    $addressLine4: String
    $town: String
    $county: String
    $region: String
    $postCode: String
    $countryId: String!
    $action: String!
  ) {
    addEntityContact(
      entityId: $entityId
      addressType: $addressType
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      addressLine3: $addressLine3
      addressLine4: $addressLine4
      town: $town
      county: $county
      region: $region
      postCode: $postCode
      countryId: $countryId
      action: $action
    ) {
      statusCode
      message
    }
  }
`;

export const UPDATE_ENTITY_CONTACT = gql`
  mutation (
    $id: String!
    $entityId: String!
    $addressType: String!
    $addressLine1: String!
    $addressLine2: String
    $addressLine3: String
    $addressLine4: String
    $town: String
    $county: String
    $region: String
    $postCode: String
    $countryId: String!
  ) {
    updateEntityContact(
      id: $id
      entityId: $entityId
      addressType: $addressType
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      addressLine3: $addressLine3
      addressLine4: $addressLine4
      town: $town
      county: $county
      region: $region
      postCode: $postCode
      countryId: $countryId
    ) {
      statusCode
      message
    }
  }
`;

export const GET_RELATED_ENTITIES = gql`
  query ($entityId: String) {
    getRelatedEntities(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;

export const CREATE_RELATED_ENTITY = gql`
  mutation (
    $entityId: String!
    $relationType: String!
    $relatedLocalEntityId: String
    $relatedMdmId: String
    $relatedDnbId: String
    $entityName: String
    $entityCategory: String
    $addressLine1: String
    $addressLine2: String
    $addressLine3: String
    $addressLine4: String
    $city: String
    $county: String
    $stateProvince: String
    $region: String
    $postCode: String
    $countryId: String
  ) {
    createRelatedEntity(
      entityId: $entityId
      relationType: $relationType
      relatedLocalEntityId: $relatedLocalEntityId
      relatedMdmId: $relatedMdmId
      relatedDnbId: $relatedDnbId
      entityName: $entityName
      entityCategory: $entityCategory
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      addressLine3: $addressLine3
      addressLine4: $addressLine4
      city: $city
      county: $county
      stateProvince: $stateProvince
      region: $region
      postCode: $postCode
      countryId: $countryId
    ) {
      statusCode
      message
    }
  }
`;

export const DELETE_RELATED_ENTITY = gql`
  mutation ($entityId: String!, $relatedEntityId: String!) {
    removeRelatedEntity(
      entityId: $entityId
      relatedEntityId: $relatedEntityId
    ) {
      statusCode
      message
    }
  }
`;

export const GET_DATA_AUGMENTATION = gql`
  query (
    $entityId: String
    $sources: [String]
    $action: String
    $pagination: [pagination]
  ) {
    getAugmentationData(
      entityId: $entityId
      sources: $sources
      action: $action
      pagination: $pagination
    ) {
      statusCode
      message
      data
    }
  }
`;

export const IMPORT_EXTERNAL_DOCUMENTS = gql`
  mutation ($entityId: String!, $documents: [documents]) {
    importExternalDocuments(entityId: $entityId, documents: $documents) {
      statusCode
      message
    }
  }
`;

export const GET_DATA_AUGMENTATION_SOURCES = gql`
  query ($entityId: String) {
    getAugmentationSources(entityId: $entityId) {
      statusCode
      message
      data
    }
  }
`;
